import React, { useState, useEffect } from 'react';
import { useParams, Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { Layout, Link, Jumbotron, Stat, Panel } from '@components'
import { Account } from '@archetypes'
import { Pool } from '@archetypes'
import styled from "styled-components"
import assetController from '@app/App.Controller'
import { ReactComponent as IconAddLiquidity } from "@assets/Icon_Add_Liquidity.svg"
import { ReactComponent as IconRemoveLiquidity } from "@assets/Icon_Remove_Liquidity.svg"
import { ReactComponent as ArrowRight } from '@assets/Icon_Arrow_Right.svg';
import { ReactComponent as ArrowLeft } from '@assets/Icon_Arrow_Left.svg';



const Stake = ({ className }) => {

	const { perlinx } = assetController
	const [stats, setStats] = useState()

	useEffect(() => {
		const sub = perlinx.state.subscribe('stats', setStats, true)
		return () => sub.unsubscribe()
	}, []) // eslint-disable-line

	return <Layout>
		<Layout.Main>
			<Jumbotron
				title="Liquidity Pools"
				navs={
					<>
						<a href="https://medium.com/perlin-network" target="_blank"><Link.Info content="Learn More" /></a>
						<Link.Dashboard />
					</>}
			>
				<Stat title='Total Value Locked'>
					${(Number(stats?.tvl) || 0).toLocaleString()}
				</Stat>
			</Jumbotron>

			<Layout.Section title='Your Pools'>
				<Account.Pools />
			</Layout.Section>
			<Layout.Section title='All Liquidity Pools'>
				<Pool.LiquidityV3 />
			</Layout.Section>
		</Layout.Main>
	</Layout>
}


const Extension = styled.div`
	background-color: #132A3E;
	display: flex;
	padding: 0;
	max-height: 0;
	overflow: hidden;
	transition: all 0.5s;
	flex-direction: column;
	margin-top: -5px;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;

	font-size: 14px;
	font-weight: 400;
	
	.-row {
        display: flex;
        flex-direction: row;
        padding: 20px;
        padding-top: 5px;
        padding-bottom: 5px;
        >div { 
            flex: 30%;
            color: var(--color-label);
            :last-child {
                flex: 70%;
                color: var(--color-white);
                text-align: right;
            }
        }
    }

    ${props => props.visible && `
        max-height: 200px;
        padding: 20px;
    `}

`

const ReturnIcon = styled(
	({ className, setPanel }) => (<ArrowLeft onClick={() => setPanel()} className={className} />))`
	width: 32px;
	height: 32px;
	cursor: pointer;
	margin-right: 2rem;
	`

const PanelHeader = ({ title, subtitle, setPanel }) => {
	return (
		<div style={{ display: "flex", flexDirection: "row" }}>
			<ReturnIcon
				setPanel={setPanel}
			/>
			<div className="subpanel">
				<h4>
					{title}
				</h4>
				<p>{subtitle}</p>
			</div>
		</div>
	)
}

const options = [
	{
		id: 1,
		title: "Add liquidity",
		subtitle: "Add liquidity by staking tokens in pool",
		icon: <IconAddLiquidity />
	},
	{
		id: 2,
		title: "Withdraw liquidity",
		subtitle: "Withdraw your tokens from liquidity pool",
		icon: <IconRemoveLiquidity />
	}
]

const Join = styled(
	({ className }) => {
		let { address } = useParams();
		const [panel, setPanel] = useState()

		const [extensions, setExtensions] = useState([])

		useEffect(() => {
			setExtensions([])
		}, [panel])

		return (
			<>
				<Layout>
					<Layout.Main>
						<Layout.Section>
							<Pool.Stats
								address={address}
							/>
						</Layout.Section>
					</Layout.Main>
				</Layout>
				<Layout className={className}>
					<Layout.Aside>
						<Pool.MyStakePanel address={address} />
					</Layout.Aside>
					<Layout.Main>
						{!panel &&
							(
								<Panel fadeIn>
									<h4>
										Manage Liquidity
                					</h4>
									<div className="options-wrapper">
										{options.map((option, index) => (
											<div key={index}>
												<div className="option">
													<div>
														{option.icon}
													</div>
													<div className="description">
														<h4>{option.title}</h4>
														<p>{option.subtitle}</p>
													</div>
													<div>
														<ArrowRight onClick={() => setPanel(option.id)} className="arrow" />
													</div>
												</div>
												<Panel.Divider noMargin light />
											</div>
										))}
									</div>
								</Panel>
							)}
						{panel === 1 &&
							(
								<>
									<Panel fadeIn>
										<PanelHeader
											title={options[0].title}
											subtitle={options[0].subtitle}
											setPanel={setPanel}
										/>
										<Panel.Divider light />
										<Pool.Stake
											address={address}
											setExtensions={setExtensions}
										/>
									</Panel>
								</>
							)
						}
						{panel === 2 &&
							(
								<>
									<Panel fadeIn>
										<PanelHeader
											title={options[1].title}
											subtitle={options[1].subtitle}
											setPanel={setPanel}
										/>
										<Panel.Divider light />
										<Pool.Withdraw
											address={address}
											setExtensions={setExtensions}
										/>
									</Panel>
								</>
							)}
						<Extension
							visible={extensions.length > 0}
						>
							{extensions.map((extension, index) => (
								<div className="-row" key={index}>
									<div>{extension?.key}</div>
									<div>
										{extension?.value}
									</div>
								</div>
							))}
						</Extension>
					</Layout.Main>
				</Layout>
			</>
		)
	})`
	margin-top: 3rem;
	h4 {
        font-size: 16px;
        margin: 0px;
        color: var(--color-label, lightblue);
	}
	
	.options-wrapper {
		padding-top: 3rem;
		padding-bottom: 3rem;
	}

	.option {
		display: flex;
		flex-direction: row;
		margin: 0px;
		padding-top: 2rem;
		padding-bottom: 2rem;

		>.description {
			flex-direction: column;
			margin-top: auto;
			margin-bottom: auto;
			h4,p {
				margin: 0px;
			}
			p, h4 {
				line-height: 24px;
			}
			h4 {
				color: var(--color-white);
				font-size: 16px;
			}
			p {
				color: var(--color-label, lightblue);
				font-size: 14px;
			}
			 
		}

		svg {
			width: 56px;
			height: 56px;
			margin-left: auto;
			margin-right: auto;
		}
		.arrow {
			width: 32px;
			height: 32px;
			margin: auto;
			cursor: pointer; 
		}

		div {
			flex 5;
			display: flex;
			:first-child, :last-child {
				flex 1;
			}
			
		}
		
	}

	.subpanel {
		display: flex;
		flex-direction: column;
		h4 , p {
			margin: 0px;
			font-weight: 600;
		}
		h4 {
			font-size: 18px;
			line-height: 32px;
			color: var(--color-white);
		}
		p {
			font-size: 14px;
			line-height: 24px;
			color: var(--color-label, lightblue);
		}
	}

	`


export default ({ className }) => {
	let { path } = useRouteMatch()
	return (
		<Switch>
			<Route exact path={path} component={Stake} />
			<Route exact path={`${path}/:address`} component={Join} />
			<Redirect to={path} />
		</Switch>
	)
}